import React, { useState } from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  background: #fdfdfd;
  padding: 80px 5%;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 60px; /* Better spacing */

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const FaqSection = styled.div`
  flex: 1.1; /* slightly wider */
`;

const AccordionContainer = styled.div`
  margin-bottom: 16px;
  background: #ffffff;
  border-radius: 8px; /* softer border radius */
  box-shadow: 0 2px 8px rgba(0,0,0,0.06); /* higher contrast shadow */
  overflow: hidden;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #25aae3;
    box-shadow: 0 4px 15px rgba(37,170,227,0.15);
  }
`;

const AccordionHeader = styled.div`
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: ${({ isOpen }) => isOpen ? '#f0f9ff' : '#ffffff'};
  transition: background 0.3s ease;
`;

const Question = styled.h4`
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  color: ${({ isOpen }) => isOpen ? '#1c94c9' : '#1a202c'}; /* Darker base */
  font-weight: 700;
  transition: color 0.3s ease;
`;

const Answer = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  padding: ${({ isOpen }) => (isOpen ? '0 24px 20px 24px' : '0 24px')};
  background: #f0f9ff;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  color: #4a5568; /* better contrast */
  line-height: 1.7;
  transition: all 0.4s ease-in-out;
`;

const Testimonial = styled.div`
  flex: 0.9;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 50px 40px;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0,0,0,0.08); /* bolder shadow */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const InitialQuote = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  color: #4a5568; /* Better contrast */
  line-height: 1.7;
  margin: 30px 0;
  font-style: italic;
  font-weight: 500;
`;

const Author = styled.a`
  font-weight: 800;
  font-size: 16px;
  color: #1a202c;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #25aae3;
    text-decoration: underline;
  }
`;

const Followers = styled.div`
  font-size: 14px;
  color: #718096;
  margin-top: 6px;
  font-weight: 600;
`;

const AvatarImg = styled.img`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 4px solid #e1eff6;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
`;

const faqs = [
  { question: "How does Gainsta Work?", answer: "Gainsta works by safely automating interactions with real accounts in your niche, turning automated activity into a huge flow of real followers and engagement." },
  { question: "Are the followers I am gaining real?", answer: "Yes! All followers you gain using our platform are 100% real users who chose to follow your account due to mutual interests." },
  { question: "Will my account be safe?", answer: "Absolutely. We follow Instagram's best practices and limits natively to ensure your account will never be blocked or banned." },
  { question: "Can I try Gainsta for free?", answer: "At Gainsta, we offer a 7 day money back guarantee! This means that if you aren't satisfied with the service for any reason in 7 days, we will give you a full refund – no questions asked!" },
  { question: "How fast will my accounts grow?", answer: "Growth depends heavily on your niche and content quality, but our average user gains between 1,000 to 3,000 new, highly engaged followers a month." },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(3);

  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <SectionWrapper id="faq">
      <Container>
        <FaqSection>
          {faqs.map((faq, idx) => (
            <AccordionContainer key={idx}>
              <AccordionHeader isOpen={openIndex === idx} onClick={() => toggleOpen(idx)}>
                <Question isOpen={openIndex === idx}>{faq.question}</Question>
                <span style={{ color: openIndex === idx ? '#25aae3' : '#a0aec0', fontWeight: 'bold', fontSize: '20px' }}>
                  {openIndex === idx ? '-' : '+'}
                </span>
              </AccordionHeader>
              <Answer isOpen={openIndex === idx}>
                {faq.answer}
              </Answer>
            </AccordionContainer>
          ))}
        </FaqSection>
        <Testimonial>
          <AvatarImg src="/menhairstyle.png" alt="@menhairstyle" />
          <InitialQuote>
            “Gainsta has been one of the most professional companies I've ever worked with. Their SMM tools
            have helped us achieve our goals of reaching more targeted people that have directly benefited
            our business and our community. I'm currently up to 94,000 followers and still growing fast!”
          </InitialQuote>
          <Author href="https://www.instagram.com/menhairstyle" target="_blank" rel="noopener noreferrer">@menhairstyle</Author>
          <Followers>94,000+ Followers</Followers>
        </Testimonial>
      </Container>
    </SectionWrapper>
  );
};

export default FAQ;
